import { render, staticRenderFns } from "./cTableBa.vue?vue&type=template&id=8ea1304a&scoped=true"
import script from "./cTableBa.vue?vue&type=script&lang=js"
export * from "./cTableBa.vue?vue&type=script&lang=js"
import style0 from "./cTableBa.vue?vue&type=style&index=0&id=8ea1304a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea1304a",
  null
  
)

export default component.exports